export default __webpack_public_path__ + "static/media/castagnaTtsIt_It60.bc9c44f7.mp3";